import type React from 'react';
import { hasStoredSession, prefetchOidcMetadata, startLogin } from './oidc';

/**
 * Клик по ссылке «Личный кабинет» на сайте. Без сохранённого входа сразу
 * уходим на портал входа: раньше сначала грузилась панель, мелькал её пустой
 * каркас и только потом начинался редирект.
 */
export function onPanelLinkClick(e: React.MouseEvent<HTMLAnchorElement>, to: string): void {
  // Новая вкладка (Ctrl/Cmd/средняя кнопка) — пусть открывается как обычно
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (hasStoredSession()) return;
  e.preventDefault();
  // Портал входа недоступен — открываем кабинет как раньше, он сам покажет вход
  startLogin(to).catch(() => { window.location.href = to; });
}

/** Наведение на ссылку: заранее подтягиваем адреса портала входа. */
export function onPanelLinkHover(): void {
  if (!hasStoredSession()) prefetchOidcMetadata();
}
